// Functions for formatting currency
const isFormattable = (price?: number): price is number => Number.isFinite(price);

// Not exported: shared by the formatters below, so the style and the fraction digits live in one place.
const usePriceFormatter = (currency: string, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  const { locale } = useI18n();
  return new Intl.NumberFormat(locale.value, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const usePriceFormatToParts = (
  price?: number,
  currencyRate = 1,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
): Intl.NumberFormatPart[] => {
  if (!isFormattable(price)) {
    return [{ type: 'literal', value: 'N/A' }];
  }
  const { currency } = storeToRefs(useCurrencyStore());
  return usePriceFormatter(currency.value, minimumFractionDigits, maximumFractionDigits).formatToParts(
    price * currencyRate,
  );
};

export const usePriceFormat = (
  price?: number,
  currencyRate = 1,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
) => {
  if (!isFormattable(price)) {
    return 'N/A';
  }
  const { currency } = storeToRefs(useCurrencyStore());
  return usePriceFormatter(currency.value, minimumFractionDigits, maximumFractionDigits).format(price * currencyRate);
};

// An amount settled in its own currency, whatever the site selector says.
export const usePriceFormatIn = (
  currency: string,
  price?: number,
  currencyRate = 1,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
) => {
  if (!isFormattable(price)) {
    return 'N/A';
  }
  return usePriceFormatter(currency, minimumFractionDigits, maximumFractionDigits).format(price * currencyRate);
};
